//import { data } from "jquery"
import WebService from "../../WebService"

const Booth = {
    gets(params) {
        return WebService.get("/console/contest/booths?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/booths/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/booths", data)
    },
    update(data) {
        return WebService.post("/console/contest/booths/" + data.booth_id, data)
    },
    getMembers(slug, data) {
        return WebService.get("/console/contest/companies/"+slug+"/members?currentPage=1&perPage=30&e="+data.e)
    }
}
export default Booth